<template>
    <div>
        <ul class="nav nav-tabs">
            <li class="nav-item">
                <div
                    class="nch--custom-tab"
                    href="#"
                    :class="{active: currentTab === 'OptionsOverview'}"
                    @click.stop.prevent="setTab('OptionsOverview')"
                >
                    <i class="mdi mdi-file-document-box-outline"></i>
                    <span>{{$t('common.overview')}}</span>
                </div>
            </li>
            <li class="nav-item" v-if="content.files && content.files.length > 0">
                <div
                    class="nch--custom-tab"
                    href="#"
                    :class="{active: currentTab === 'OptionsSupport'}"
                    @click.stop.prevent="setTab('OptionsSupport')"
                >
                    <i class="mdi mdi-paperclip"></i>
                    <span>{{$t('common.support_material')}}</span>
                </div>
            </li>
            <!-- Fórum exige conta: oculto no acesso anônimo (backlog#410) -->
            <li class="nav-item" v-if="lesson.forum && !isPublic">
                <div
                    class="nch--custom-tab"
                    href="#"
                    :class="{active: currentTab === 'OptionsForum'}"
                    @click.stop.prevent="setTab('OptionsForum')"
                >
                    <i class="mdi mdi-forum"></i>
                    <span>{{$t('common.forum')}}</span>
                </div>
            </li>
        </ul>
        <div v-if="currentTab === 'OptionsForum'">
            <component
                :is="currentTab"
                :content="content"
                :name="lesson.translation.name"
                :forum="lesson.forum"
                :lesson="lesson"
            ></component>
        </div>
        <component
            v-else
            :is="currentTab"
            :content="content"
            :name="lesson.translation.name"
            :forum="lesson.forum"
            :lesson="lesson"
        ></component>
        ...

    <!-- <base-dropdown>
        <template #title-container><li class="nav-item dropdown">
            <span class="nav-link font-weight-bold cursor-pointer">{{$t('common.anonymous')}}</span>
        </li></template>
        <span class="dropdown-item nch--nav-link">
            <i class="ni ni-user-run"></i>
            <span>{{$t('header.profile.logout')}}</span>
        </span>
    </base-dropdown> -->
    </div>
</template>

<script>
import OptionsSupport from './Options/OptionsSupportMaterial';
import OptionsOverview from './Options/OptionsOverview';
import OptionsForum from './Options/realOptionsForum';

export default {
    name: 'TabOptions',
    components: {
        OptionsSupport,
        OptionsOverview,
        OptionsForum,
    },
    props: {
        lesson: Object,
        // Acesso anônimo via URL assinada: oculta o Fórum e os downloads
        // passam a usar as URLs assinadas (backlog#410)
        isPublic: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            currentTab: 'OptionsOverview',
        };
    },
    methods: {
        setTab(option) {
            this.currentTab = option;
        },
    },
    computed: {
        content() {
            return this.$store.getters.LOADED_CONTENT;
        },
    },
};
</script>

<style scoped>
</style>
